import { FieldValidationType } from '@aibees/elephant/feature/search-filters';
import {
  isValidCompanyLinkedInUrl,
  isValidPeopleLinkedInUrl,
} from '@aibees/shared/utils';

export function useCheckLinkedinInputError(
  value: string,
  validation: FieldValidationType
) {
  if (validation === FieldValidationType.COMPANY_LINKEDIN_URL)
    return !isValidCompanyLinkedInUrl(value);
  if (validation === FieldValidationType.PEOPLE_LINKEDIN_URL)
    return !isValidPeopleLinkedInUrl(value);

  return false;
}
